import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router"
import config from '../../config.json'
import { WEISCHER } from '../../constants/itemTypes'
import toJS from '../../hoc/toJS'
import { weischerAdDeleteItem } from '../../actions'
import getData from '../../functions/getData'
import { AUTH_CAPS, PROGRAM_WEISCHERAD_ITEMS } from '../../constants/state'
import { WEISCHER_MAIN } from '../../constants/weischerTypes'
import ListDrag from '../../components/DragAndDropList/presents/ListDrag'
import canEditProgram from '../../functions/canEditProgram'
import dndItemTypes from '../../constants/dndItemTypes'
import ProgramDragDropItemSwitch from '../../components/PageEditSelection/ProgramDragDropItemSwitch'

const mapStateToProps = state => ({
    items: getData(state, PROGRAM_WEISCHERAD_ITEMS),
    caps: getData(state, AUTH_CAPS)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    removeItem: (itemID) => {
        dispatch(weischerAdDeleteItem(itemID))
    }
})

const ProgramListWeischerAdContainer = ({
    titleTransId, 
    buttonTextTransId,
    className, 
    items,
    caps, 
    match,
    isAllOpen,
    setAllOpen,
    removeItem
}) => {
    const { selectionId, selectionType } = match.params

    const basicUrl = `${config.routes.program.path}/${selectionType}/${selectionId}`
    const pathnameAdd = `${basicUrl}/${WEISCHER}/addItem/form`
    const canEdit = canEditProgram(caps)

    const mainItems = {}
    const mainOrder = []
    
    Object.keys(items).map(itemId => {
        const item = items[itemId]

        if(WEISCHER_MAIN === item.type) {
            mainOrder.push(itemId)
            mainItems[itemId] = item
        }
    })

    return <ListDrag
        titleTransId={titleTransId}
        buttonTextTransId={buttonTextTransId}
        listId={'weischer-' + selectionId}
        dndType={dndItemTypes.PROGRAM_ITEM_AD}
        className={className}

        type={WEISCHER}

        order={mainOrder}
        items={mainItems}

        ChildSwitchItem={ProgramDragDropItemSwitch}

        params={false}
        basicUrl={basicUrl}

        defaultIsOpen={isAllOpen}
        setAllOpen={setAllOpen}

        canEdit={canEdit}
        canDelete={canEdit}
        pathnameAdd={pathnameAdd}
        deleteItem={removeItem}
    />
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(ProgramListWeischerAdContainer)